module.exports = __webpack_public_path__ + "russierenouvelables/img/geo-map.72e1519d.webp";